module.exports = __webpack_public_path__ + "static/coliving-bedroom-3-3b34e8ef591b4b1c550578a964aeaaf8.jpg";